import { Stack } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { DashboardComponents } from "@/features/dashboard/_components/dashboard";
import { ShippingForm } from "@/features/dashboard/transportadoras/components/ShippingForm";


export const Route = createFileRoute("/_private/dashboard/_base/transportadoras/_forms/cadastrar/")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <Stack>
      <DashboardComponents.Title>Cadastrar Transportadora</DashboardComponents.Title>

      <ShippingForm />
    </Stack>
  );
}
